import Box from '@mui/material/Box';
import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import {RootState} from '../../reducer';
import {PostInterface} from '../../interface/post.interface';
import 'react-quill/dist/quill.bubble.css';
import ReplyEditor from './editor/ReplyEditor';
import {ReplyInterface} from '../../interface/reply.interface';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import {Avatar, Tooltip} from "@mui/material";
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import {MenuInterface} from "../../interface/menu.interface";

const AVATAR_PALETTE = [
    '#5383ec', '#7a55c4', '#3aa17e', '#d97757', '#c0457a',
    '#5e8a3b', '#b4842c', '#3d8f9e', '#7f5da6', '#c2664c',
];

function getAvatarColor(name: string): string {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) | 0;
    }
    return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
}

function getInitial(name: string): string {
    const trimmed = (name || '').trim();
    return trimmed ? trimmed.charAt(0) : '?';
}

interface State {
    contents: string,
}

type CreateReplyType = {
    post: string,
    content: string,
    id: string,
}

export default function ReplyList(props: { post: PostInterface, menu: MenuInterface }) {
    console.log('[ReplyList]');
    const commonData = useSelector((state: RootState) => state.commonData);
    const [state, setState] = useState<State>({
        contents: '',
    });

    const [reReplyState, setReReplyState] = useState({
        contents: '', reply: '',
    })

    const [updateState, setUpdateState] = useState({
        contents: '', selectedReply: ''
    });


    const [replyList, setReplyList] = useState([]);

    let {id, workplace, no, page} = common.getQuery();

    useEffect(() => {
        if (props.post._id !== '') {
            axios.get(constance.api.getReplyList, {
                params: {
                    _id: props.post._id,
                    id: id,
                },
            }).then(value => {

                setReplyList(value.data.data);
            }).catch(reason => {
                console.log(reason);
            });
        }
    }, [props.post]);

    function handleSaveReply() {
        if (state.contents.length == 0) {
            common.alert('내용을 입력해주세요', '', 'warning');
            return;
        }

        let params: CreateReplyType = {
            content: state.contents,
            post: props.post._id,
            id: id,
        };
        axios.post(constance.api.createReply, {
            ...params,
        }).then(value => {
            console.log('createReply', value);
            setState({
                ...state,
                contents: ''
            })
            setReplyList(value.data.replyList)
        }).catch(reason => {
            console.error(reason);
        }).finally(() => {
        });
    }

    function deleteReply(reply: ReplyInterface) {
        axios.post(constance.api.deleteReply, {
            values: {
                reply: reply._id,
            },
        }).then(value => {
            setReplyList(value.data.replyList)
        });
    }

    function openUpdateReply(reply: ReplyInterface) {
        setUpdateState({
            ...updateState,
            contents: reply.content,
            selectedReply: reply._id,
        })
    }

    function handleUpdateReply() {
        if (updateState.contents.length == 0) {
            common.alert('내용을 입력해주세요', '', 'warning');
            return;
        }

        let params: { content: string, reply: string, post: string, id: string } = {
            content: updateState.contents,
            reply: updateState.selectedReply,
            post: props.post._id,
            id: id,
        };
        axios.post(constance.api.updateReply, {
            ...params,
        }).then(value => {
            console.log('updateReply', value);
            setUpdateState({
                ...updateState,
                selectedReply: '',
                contents: '',
            })
            setReplyList(value.data.replyList)
        }).catch(reason => {
            console.error(reason);
        }).finally(() => {
        });
    }


    function handleSaveReReply() {
        if (reReplyState.contents.length == 0) {
            common.alert('내용을 입력해주세요', '', 'warning');
            return;
        }

        let params: { content: string, post: string, _id: string } = {
            content: reReplyState.contents,
            post: props.post._id,
            _id: reReplyState.reply
        };
        axios.post(constance.api.createReply, {
            ...params,
        }).then(value => {
            console.log('createReReply', value);
            setReReplyState({
                ...reReplyState,
                reply: '',
                contents: ''
            })
            setReplyList(value.data.replyList)
        }).catch(reason => {
            console.error(reason);
        }).finally(() => {
        });
    }

    function openReReplyEditor(reply: ReplyInterface) {
        if (props.menu.allowAdminReply && !commonData.user.admin) {
            return;
        }
        setReReplyState({
            ...reReplyState,
            contents: '',
            reply: reply._id === reReplyState.reply ? '' : reply._id,
        })
    }


    function ReReplyBox() {
        return <Box sx={{width: 1, display: 'flex', justifyContent: 'flex-end'}}>
            {/* 댓글 에디터 */}
            <Box sx={{width: 0.97, display: 'flex', mt: 3, alignItems: 'center'}}>
                <SubdirectoryArrowRightIcon sx={{mr: 1}}/>
                <ReplyEditor contents={reReplyState.contents}
                             state={reReplyState}
                             setState={setReReplyState}
                             style={{
                                 width: '90%',
                                 background: 'var(--scc-surface-muted)',
                                 border: styles.border,
                             }}
                />
                <Button onClick={handleSaveReReply}
                        variant={'contained'}
                        color={'neutral'}
                        sx={{ml: 1, width: '10%', height: 1}}>
                    <Typography>댓글등록</Typography>
                </Button>
            </Box>
        </Box>
    }

    return (
        <>
            <Box sx={{display: 'flex', width: 1, mt: 2, justifyContent: 'center'}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    mb: 2,
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 2,
                    background: 'var(--scc-card-bg)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    p: {xs: 2, md: 3},
                }}>
                    {/* 댓글 헤더 */}
                    <Typography variant="subtitle1" sx={{fontWeight: 600, mb: 1.5}}>
                        {`댓글 ${replyList.length}`}
                    </Typography>
                    <Stack sx={{width: 1}}>

                        {
                            replyList.map((reply: ReplyInterface, index) => {
                                const isMine = reply.user._id === commonData.user._id;
                                const isEditing = updateState.selectedReply === reply._id;
                                const isReply = reply.depth > 0;
                                const displayName = `${reply.user.departmentName} ${reply.user.name}`;
                                const avatarColor = getAvatarColor(displayName);
                                // @ts-ignore
                                return <Box key={index}
                                            onClick={isEditing ? undefined : () => openReReplyEditor(reply)}
                                            sx={{
                                                display: 'flex',
                                                gap: 1.5,
                                                py: 1.5,
                                                pl: isReply ? (isMobile ? 1.5 : 2) : 0,
                                                ml: isReply ? (isMobile ? 1.5 : 3) : 0,
                                                borderLeft: isReply ? '2px solid' : 'none',
                                                borderColor: 'divider',
                                                borderBottom: index === replyList.length - 1 ? 'none' : '1px solid',
                                                borderBottomColor: 'divider',
                                                cursor: isEditing ? 'default' : 'pointer',
                                                transition: 'background-color 0.2s',
                                                '&:hover .reply-actions': {opacity: 1},
                                                '&:hover': {
                                                    backgroundColor: 'var(--scc-card-meta-bg)',
                                                },
                                            }}>
                                    {/* 아바타 */}
                                    <Avatar
                                        sx={{
                                            width: isReply ? 28 : 32,
                                            height: isReply ? 28 : 32,
                                            fontSize: isReply ? 13 : 14,
                                            fontWeight: 600,
                                            bgcolor: avatarColor,
                                            color: '#fff',
                                            flexShrink: 0,
                                            mt: 0.25,
                                        }}>
                                        {getInitial(reply.user.name)}
                                    </Avatar>

                                    {/* 우측: 헤더 + 본문 */}
                                    <Stack sx={{flex: 1, minWidth: 0, gap: 0.5}}>
                                        <Stack direction="row"
                                               sx={{
                                                   alignItems: 'center',
                                                   justifyContent: 'space-between',
                                                   flexWrap: 'wrap',
                                                   rowGap: 0.25,
                                               }}>
                                            <Stack direction="row" alignItems="baseline" sx={{gap: 1, minWidth: 0}}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontWeight: 600,
                                                        ...styles.textHidden,
                                                    }}>
                                                    {displayName}
                                                </Typography>
                                                <Typography variant="caption" sx={{color: 'text.secondary', flexShrink: 0}}>
                                                    {common.getTimeFormat(reply.createdAt)}
                                                </Typography>
                                            </Stack>
                                            {isMine && (
                                                <Stack
                                                    direction="row"
                                                    className="reply-actions"
                                                    onClick={(e) => e.stopPropagation()}
                                                    sx={{
                                                        gap: 0.5,
                                                        flexShrink: 0,
                                                        opacity: {xs: 1, md: 0},
                                                        transition: 'opacity 0.2s',
                                                    }}>
                                                    <Tooltip title="수정">
                                                        <ModeEditIcon color="action"
                                                                      onClick={() => openUpdateReply(reply)}
                                                                      sx={{cursor: 'pointer', fontSize: 18}}/>
                                                    </Tooltip>
                                                    <Tooltip title="삭제">
                                                        <DeleteIcon color="error"
                                                                    onClick={() => deleteReply(reply)}
                                                                    sx={{cursor: 'pointer', fontSize: 18}}/>
                                                    </Tooltip>
                                                </Stack>
                                            )}
                                        </Stack>

                                        {/* 본문 or 수정 에디터 */}
                                        {isEditing ? (
                                            <Box sx={{display: 'flex', width: 1, mt: 0.5}}
                                                 onClick={(e) => e.stopPropagation()}>
                                                <ReplyEditor contents={updateState.contents}
                                                             state={updateState}
                                                             setState={setUpdateState}
                                                             style={{
                                                                 flex: 1,
                                                                 background: 'var(--scc-surface-muted)',
                                                                 border: styles.border,
                                                             }}
                                                />
                                                <Button onClick={handleUpdateReply}
                                                        size="small"
                                                        variant="contained"
                                                        color="neutral"
                                                        sx={{ml: 1, flexShrink: 0}}>
                                                    <Typography>수정</Typography>
                                                </Button>
                                            </Box>
                                        ) : (
                                            <Typography
                                                className="textHidden reply-content"
                                                dangerouslySetInnerHTML={{__html: `${reply.content}`}}
                                                sx={{
                                                    wordBreak: 'break-word',
                                                    lineHeight: 1.6,
                                                    '>p': {
                                                        margin: 0,
                                                        whiteSpace: 'pre-wrap',
                                                    },
                                                    'p>img': {maxWidth: 1},
                                                    '>video': {maxWidth: 1},
                                                }}/>
                                        )}

                                        {reply._id === reReplyState.reply && ReReplyBox()}
                                    </Stack>
                                </Box>
                            })
                        }
                    </Stack>

                    {/* 댓글 에디터 */}

                    {
                        props.menu.allowAdminReply == false || (props.menu.allowAdminReply && commonData.user.admin) ?
                            <Box sx={{width: 1, display: 'flex', mt: 3}}>
                                <ReplyEditor contents={state.contents}
                                             state={state}
                                             setState={setState}
                                             style={{
                                                 width: '90%',
                                                 background: 'var(--scc-surface-muted)',
                                                 border: styles.border,
                                             }}
                                />
                                <Button onClick={handleSaveReply}
                                        variant={'contained'}
                                        color={'neutral'}
                                        sx={{ml: 1, width: '10%'}}>
                                    <Typography>댓글등록</Typography>
                                </Button>
                            </Box>
                            : ''
                    }


                </Stack>
            </Box>
        </>
    );
}

